import {
	createBrandThemeDefinition,
	createThemePreset,
	createThemeTokens,
	extendThemeTokens,
} from '../../../app/config/theme/helpers'

const defaultLight = createThemeTokens({
	background: 'oklch(0.9818 0.0054 95.0986)',
	foreground: 'oklch(0.3438 0.0269 95.7226)',
	card: 'oklch(0.9818 0.0054 95.0986)',
	'card-foreground': 'oklch(0.1908 0.0020 106.5859)',
	popover: 'oklch(1.0000 0 0)',
	'popover-foreground': 'oklch(0.2671 0.0196 98.9390)',
	primary: 'oklch(0.6171 0.1375 39.0427)',
	'primary-foreground': 'oklch(1.0000 0 0)',
	secondary: 'oklch(0.9245 0.0138 92.9892)',
	'secondary-foreground': 'oklch(0.4334 0.0177 98.6048)',
	muted: 'oklch(0.9341 0.0153 90.2390)',
	'muted-foreground': 'oklch(0.6059 0.0075 97.4233)',
	accent: 'oklch(0.9245 0.0138 92.9892)',
	'accent-foreground': 'oklch(0.2671 0.0196 98.9390)',
	destructive: 'oklch(0.1908 0.0020 106.5859)',
	'destructive-foreground': 'oklch(1.0000 0 0)',
	border: 'oklch(0.8847 0.0069 97.3627)',
	input: 'oklch(0.7621 0.0156 98.3528)',
	ring: 'oklch(0.6171 0.1375 39.0427)',
	'chart-1': 'oklch(0.5583 0.1276 42.9956)',
	'chart-2': 'oklch(0.6898 0.1581 290.4107)',
	'chart-3': 'oklch(0.8816 0.0276 93.1280)',
	'chart-4': 'oklch(0.8822 0.0403 298.1792)',
	'chart-5': 'oklch(0.5608 0.1348 42.0584)',
	sidebar: 'oklch(0.9663 0.0080 98.8792)',
	'sidebar-foreground': 'oklch(0.3590 0.0051 106.6524)',
	'sidebar-primary': 'oklch(0.6171 0.1375 39.0427)',
	'sidebar-primary-foreground': 'oklch(0.9881 0 0)',
	'sidebar-accent': 'oklch(0.9245 0.0138 92.9892)',
	'sidebar-accent-foreground': 'oklch(0.3250 0 0)',
	'sidebar-border': 'oklch(0.9401 0 0)',
	'sidebar-ring': 'oklch(0.7731 0 0)',
	'font-sans':
		"ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
	'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
	'font-mono':
		'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
	radius: '0.5rem',
	'shadow-x': '0',
	'shadow-y': '1px',
	'shadow-blur': '3px',
	'shadow-spread': '0px',
	'shadow-opacity': '0.1',
	'shadow-color': 'oklch(0 0 0)',
	'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
	'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
	'shadow-sm':
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
	shadow:
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
	'shadow-md':
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
	'shadow-lg':
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
	'shadow-xl':
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
	'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
	'tracking-normal': '0em',
	spacing: '0.25rem',
	'study-progress-not-started': 'var(--muted-foreground)',
	'study-progress-in-progress': 'var(--secondary-foreground)',
	'study-progress-completed': 'var(--chart-1)',
	'study-progress-deadline': 'var(--chart-5)',
	surface: 'var(--card)',
	'surface-elevated': 'oklch(0.98 0 0)',
	media: 'oklch(0.16 0 0)',
	overlay: '0 0% 0% / 0.65',
	'status-success-surface': 'oklch(0.97 0.04 145)',
	'status-success-text': 'oklch(0.42 0.12 145)',
	'status-success-border': 'oklch(0.82 0.05 145)',
	'status-warning-surface': 'oklch(0.97 0.05 85)',
	'status-warning-text': 'oklch(0.48 0.1 85)',
	'status-warning-border': 'oklch(0.84 0.06 85)',
	'status-danger-surface': 'oklch(0.97 0.05 25)',
	'status-danger-text': 'oklch(0.45 0.14 25)',
	'status-danger-border': 'oklch(0.83 0.06 25)',
	'status-info-surface': 'oklch(0.97 0.03 250)',
	'status-info-text': 'oklch(0.45 0.1 250)',
	'status-info-border': 'oklch(0.83 0.04 250)',
	success: 'var(--status-success-text)',
	warning: 'var(--status-warning-text)',
	info: 'var(--status-info-text)',
	danger: 'var(--status-danger-text)',
	'carousel-slide-0': 'oklch(0.35 0.08 39)',
	'carousel-slide-0-foreground': 'oklch(0.98 0.005 95)',
	'carousel-slide-1': 'oklch(0.40 0.06 90)',
	'carousel-slide-1-foreground': 'oklch(0.98 0.005 95)',
	'carousel-slide-2': 'oklch(0.30 0.10 43)',
	'carousel-slide-2-foreground': 'oklch(0.98 0.005 95)',
	'carousel-slide-3': 'oklch(0.45 0.04 95)',
	'carousel-slide-3-foreground': 'oklch(0.98 0.005 95)',
	'carousel-slide-4': 'oklch(0.38 0.07 42)',
	'carousel-slide-4-foreground': 'oklch(0.98 0.005 95)',
	'reading-foreground': 'var(--foreground)',
	'border-strong': 'var(--input)',
	gold: 'var(--secondary)',
	'gold-text': 'var(--secondary)',
	'gold-wash': 'var(--muted)',
})

const defaultDark = createThemeTokens({
	background: 'oklch(0.2679 0.0036 106.6427)',
	foreground: 'oklch(0.8074 0.0142 93.0137)',
	card: 'oklch(0.2679 0.0036 106.6427)',
	'card-foreground': 'oklch(0.9818 0.0054 95.0986)',
	popover: 'oklch(0.3085 0.0035 106.6039)',
	'popover-foreground': 'oklch(0.9211 0.0040 106.4781)',
	primary: 'oklch(0.6724 0.1308 38.7559)',
	'primary-foreground': 'oklch(1.0000 0 0)',
	secondary: 'oklch(0.9818 0.0054 95.0986)',
	'secondary-foreground': 'oklch(0.3085 0.0035 106.6039)',
	muted: 'oklch(0.2213 0.0038 106.7070)',
	'muted-foreground': 'oklch(0.7713 0.0169 99.0657)',
	accent: 'oklch(0.2130 0.0078 95.4245)',
	'accent-foreground': 'oklch(0.9663 0.0080 98.8792)',
	destructive: 'oklch(0.6368 0.2078 25.3313)',
	'destructive-foreground': 'oklch(1.0000 0 0)',
	border: 'oklch(0.3618 0.0101 106.8928)',
	input: 'oklch(0.4336 0.0113 100.2195)',
	ring: 'oklch(0.6724 0.1308 38.7559)',
	'chart-1': 'oklch(0.5583 0.1276 42.9956)',
	'chart-2': 'oklch(0.6898 0.1581 290.4107)',
	'chart-3': 'oklch(0.2130 0.0078 95.4245)',
	'chart-4': 'oklch(0.3074 0.0516 289.3230)',
	'chart-5': 'oklch(0.5608 0.1348 42.0584)',
	sidebar: 'oklch(0.2357 0.0024 67.7077)',
	'sidebar-foreground': 'oklch(0.8074 0.0142 93.0137)',
	'sidebar-primary': 'oklch(0.3250 0 0)',
	'sidebar-primary-foreground': 'oklch(0.9881 0 0)',
	'sidebar-accent': 'oklch(0.1680 0.0020 106.6177)',
	'sidebar-accent-foreground': 'oklch(0.8074 0.0142 93.0137)',
	'sidebar-border': 'oklch(0.9401 0 0)',
	'sidebar-ring': 'oklch(0.7731 0 0)',
	'font-sans':
		"ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
	'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
	'font-mono':
		'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
	radius: '0.5rem',
	'shadow-x': '0',
	'shadow-y': '1px',
	'shadow-blur': '3px',
	'shadow-spread': '0px',
	'shadow-opacity': '0.1',
	'shadow-color': 'oklch(0 0 0)',
	'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
	'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
	'shadow-sm':
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
	shadow:
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
	'shadow-md':
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
	'shadow-lg':
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
	'shadow-xl':
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
	'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
	'tracking-normal': '0em',
	spacing: '0.25rem',
	'study-progress-not-started': 'var(--muted-foreground)',
	'study-progress-in-progress': 'var(--secondary-foreground)',
	'study-progress-completed': 'var(--chart-1)',
	'study-progress-deadline': 'var(--chart-5)',
	surface: 'oklch(0.18 0 0)',
	'surface-elevated': 'oklch(0.22 0 0)',
	media: 'oklch(0.1 0 0)',
	overlay: '0 0% 0% / 0.75',
	'status-success-surface': 'oklch(0.26 0.06 145)',
	'status-success-text': 'oklch(0.88 0.06 145)',
	'status-success-border': 'oklch(0.4 0.07 145)',
	'status-warning-surface': 'oklch(0.26 0.05 85)',
	'status-warning-text': 'oklch(0.9 0.07 85)',
	'status-warning-border': 'oklch(0.4 0.06 85)',
	'status-danger-surface': 'oklch(0.26 0.06 25)',
	'status-danger-text': 'oklch(0.9 0.08 25)',
	'status-danger-border': 'oklch(0.4 0.07 25)',
	'status-info-surface': 'oklch(0.26 0.04 250)',
	'status-info-text': 'oklch(0.88 0.06 250)',
	'status-info-border': 'oklch(0.4 0.05 250)',
	success: 'var(--status-success-text)',
	warning: 'var(--status-warning-text)',
	info: 'var(--status-info-text)',
	danger: 'var(--status-danger-text)',
	'carousel-slide-0': 'oklch(0.25 0.06 39)',
	'carousel-slide-0-foreground': 'oklch(0.92 0.01 93)',
	'carousel-slide-1': 'oklch(0.30 0.05 90)',
	'carousel-slide-1-foreground': 'oklch(0.92 0.01 93)',
	'carousel-slide-2': 'oklch(0.22 0.08 43)',
	'carousel-slide-2-foreground': 'oklch(0.92 0.01 93)',
	'carousel-slide-3': 'oklch(0.35 0.04 95)',
	'carousel-slide-3-foreground': 'oklch(0.92 0.01 93)',
	'carousel-slide-4': 'oklch(0.28 0.06 42)',
	'carousel-slide-4-foreground': 'oklch(0.92 0.01 93)',
	'reading-foreground': 'var(--foreground)',
	'border-strong': 'var(--input)',
	gold: 'var(--secondary)',
	'gold-text': 'var(--secondary)',
	'gold-wash': 'var(--muted)',
})

const orchardLight = extendThemeTokens(defaultLight, {
	primary: 'oklch(0.57 0.13 146)',
	secondary: 'oklch(0.91 0.03 132)',
	'secondary-foreground': 'oklch(0.29 0.03 132)',
	accent: 'oklch(0.94 0.025 120)',
	ring: 'oklch(0.57 0.13 146)',
	'chart-1': 'oklch(0.57 0.13 146)',
	'chart-5': 'oklch(0.62 0.12 120)',
	sidebar: 'oklch(0.958 0.012 126)',
	'sidebar-primary': 'oklch(0.57 0.13 146)',
	'sidebar-accent': 'oklch(0.91 0.025 126)',
	'carousel-slide-0': 'oklch(0.33 0.08 146)',
	'carousel-slide-2': 'oklch(0.28 0.09 134)',
	'carousel-slide-4': 'oklch(0.36 0.07 120)',
})

const orchardDark = extendThemeTokens(defaultDark, {
	primary: 'oklch(0.74 0.11 144)',
	secondary: 'oklch(0.26 0.03 140)',
	'secondary-foreground': 'oklch(0.91 0.02 118)',
	accent: 'oklch(0.2 0.03 124)',
	ring: 'oklch(0.74 0.11 144)',
	'chart-1': 'oklch(0.74 0.11 144)',
	'chart-5': 'oklch(0.72 0.1 120)',
	sidebar: 'oklch(0.19 0.015 130)',
	'sidebar-primary': 'oklch(0.74 0.11 144)',
	'sidebar-primary-foreground': 'oklch(0.17 0.01 132)',
	'sidebar-accent': 'oklch(0.16 0.02 130)',
	'sidebar-border': 'oklch(0.22 0.01 120)',
	'carousel-slide-0': 'oklch(0.22 0.06 144)',
	'carousel-slide-2': 'oklch(0.18 0.07 132)',
	'carousel-slide-4': 'oklch(0.24 0.05 118)',
})

const semylaTheme = createBrandThemeDefinition({
	brandKey: 'semyla',
	defaultPreset: 'default',
	presets: {
		default: createThemePreset({
			key: 'default',
			label: 'Brand default',
			description:
				'Warm agricultural palette with soft earth and harvest accents.',
			tokens: {
				light: defaultLight,
				dark: defaultDark,
			},
		}),
		orchard: createThemePreset({
			key: 'orchard',
			label: 'Orchard',
			description:
				'Greener workspace surfaces with stronger completion cues and fresher contrast.',
			tokens: {
				light: orchardLight,
				dark: orchardDark,
			},
		}),
	},
})

export default semylaTheme
